import { createFileRoute } from "@tanstack/react-router";
import { pageTitle } from "@/components/document-title";
import { DriversLicensePage } from "@/features/onboarding/pages/drivers-license-page";

export const Route = createFileRoute("/onboarding/_guarded/drivers-license")({
	head: () => pageTitle("Your Driver's License"),
	component: DriversLicensePage,
});
